import React ,{ useState,useEffect }from "react";
import classes from "./FileViewer.module.css";
import PdfViewer from "./Files/PdfViewer";

const enumFileTypeCompnent = {
    "pdf": PdfViewer,
}

const FileViewer = ({ contentDirPath='',data }) => {

    const [viewerComponent, setViewerComponent] = useState();

    useEffect(() => {
        (async () => {
            if (!data){
                setViewerComponent(<div></div>);
                return;
            }
            // const res = await fetch(`${contentDirPath}${data.url}`);
            // const resBlob = await res.blob();
            // const fileType = resBlob.type;
            const Compnent = enumFileTypeCompnent[data.type];
            setViewerComponent(<Compnent contentDirPath={contentDirPath} data={data}></Compnent>)
        })()

    }, [data])


    return <div className={classes.FileViewer}>
        {viewerComponent}
    </div>
}

export default FileViewer;